import React from "react";
import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";

const ease = [0.22, 1, 0.36, 1];

const fadeInUp = {
  initial: {
    opacity: 0,
    y: 28,
  },
  animate: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.75,
      ease,
    },
  },
};

export default function Donate() {
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  return (
    <main className="-mt-10 min-h-screen bg-[#F3FBFA] px-6 sm:px-10 lg:px-16 py-16 md:py-20 text-[#163C3B] dark:bg-[#141414] dark:text-white flex items-center font-sans overflow-hidden">
      <motion.section
        ref={ref}
        initial="initial"
        animate={inView ? "animate" : "initial"}
        variants={fadeInUp}
        className="relative mx-auto w-full max-w-5xl"
      >
        <div className="relative border border-[#C7DEDA] bg-[#EAF6F4] px-7 py-12 text-center shadow-[0_18px_50px_rgba(32,82,78,0.08)] dark:border-white/10 dark:bg-[#171717] dark:shadow-black/30 md:px-14 md:py-16">
          <div className="relative mx-auto max-w-3xl">
            <p className="mb-5 text-xs sm:text-sm font-bold uppercase tracking-[0.28em] text-[#8F8120] dark:text-[#CDB937]">
              Donate to EthioCare
            </p>

            <h1
              className="mb-6 text-4xl sm:text-5xl md:text-6xl font-extrabold leading-[1.05] tracking-[-0.035em] text-[#163C3B] dark:text-white"
              style={{
                textShadow:
                  "0 2px 3px rgba(17,63,61,0.14), 0 8px 22px rgba(17,63,61,0.05)",
              }}
            >
              Support Our
              <span className="block mt-2 text-[#9A8A1D] dark:text-[#E2CD42]">
                Community
              </span>
            </h1>

            <p className="mx-auto mb-10 max-w-2xl text-base md:text-lg leading-relaxed text-[#577371] dark:text-gray-300">
              Your donation helps EthioCare continue supporting families, youth,
              newcomers, and community members across Calgary.
            </p>

            {/* E-TRANSFER */}
            <motion.div
              initial={{
                opacity: 0,
                y: 22,
              }}
              animate={
                inView
                  ? {
                      opacity: 1,
                      y: 0,
                    }
                  : {
                      opacity: 0,
                      y: 22,
                    }
              }
              transition={{
                delay: 0.18,
                duration: 0.7,
                ease,
              }}
              className="mx-auto max-w-2xl border-t border-b border-[#A7CBC6] dark:border-zinc-700 py-8 md:py-10"
            >
              <p className="mb-4 text-xs sm:text-sm font-bold uppercase tracking-[0.22em] text-[#8F8120] dark:text-[#CDB937]">
                Send E-Transfer To
              </p>

              <a
                href="mailto:info@ethiocare.ca"
                className="break-words text-3xl sm:text-4xl md:text-5xl font-extrabold tracking-[-0.03em] text-[#163C3B] dark:text-white transition-colors duration-300 hover:text-[#8F8120] dark:hover:text-[#CDB937]"
                style={{
                  textShadow: "0 2px 3px rgba(17,63,61,0.08)",
                }}
              >
                info@ethiocare.ca
              </a>
            </motion.div>

            {/* QUESTIONS */}
            <motion.div
              initial={{
                opacity: 0,
                y: 20,
              }}
              animate={
                inView
                  ? {
                      opacity: 1,
                      y: 0,
                    }
                  : {
                      opacity: 0,
                      y: 20,
                    }
              }
              transition={{
                delay: 0.3,
                duration: 0.7,
                ease,
              }}
              className="mt-8"
            >
              <p className="mb-3 text-xs sm:text-sm font-bold uppercase tracking-[0.22em] text-[#8F8120] dark:text-[#CDB937]">
                Questions?
              </p>

              <p className="text-base md:text-lg text-[#577371] dark:text-gray-300">
                Contact{" "}
                <a
                  href="tel:5877005985"
                  className="font-extrabold text-[#163C3B] dark:text-white transition-colors hover:text-[#8F8120] dark:hover:text-[#CDB937]"
                >
                  587-700-5985
                </a>{" "}
                or{" "}
                <a
                  href="tel:4037633405"
                  className="font-extrabold text-[#163C3B] dark:text-white transition-colors hover:text-[#8F8120] dark:hover:text-[#CDB937]"
                >
                  403-763-3405
                </a>
              </p>
            </motion.div>

            <motion.p
              initial={{
                opacity: 0,
              }}
              animate={
                inView
                  ? {
                      opacity: 1,
                    }
                  : {
                      opacity: 0,
                    }
              }
              transition={{
                delay: 0.45,
                duration: 0.7,
              }}
              className="mt-9 text-sm font-medium text-[#68817F] dark:text-gray-400"
            >
              Every contribution helps strengthen care, connection, and support
              in our community.
            </motion.p>
          </div>
        </div>
      </motion.section>
    </main>
  );
}